module.exports = __webpack_public_path__ + "static/media/murgor.6715814a.jpg";